import React from "react";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, SxProps, Typography } from "@mui/material";
import theme from "Theme/AppTheme";

type MessageBoxProps = {
    children: React.ReactNode;
    variant?: "error" | "info" | "success" | "warning";
    icon?: React.ReactNode;
    sx?: SxProps;
    childrenSx?: SxProps;
    childComponent?: React.ElementType;
};

export const AcxMessageBox = ({
    children,
    variant = "info",
    icon,
    sx = {},
    childrenSx: _childrenSx = {},
    childComponent = "p",
}: MessageBoxProps) => {
    const childrenSx = {
        color: "inherit",
        fontSize: "14px",
        fontWeight: 600,
        ..._childrenSx,
    };
    let color = "primary"; // Info uses primary
    if (variant === "error") {
        color = "error";
    } else if (variant === "success") {
        color = "success";
    } else if (variant === "warning") {
        color = "warning";
    }
    const textColor = theme.palette[color][700];
    let renderedIcon = icon;
    if (!renderedIcon) {
        switch (variant) {
            case "error":
                renderedIcon = <WarningRoundedIcon sx={{ color: textColor }} />;
                break;
            case "success":
                renderedIcon = (
                    <CheckCircleRoundedIcon sx={{ color: textColor }} />
                );
                break;
            case "warning":
                renderedIcon = <WarningRoundedIcon sx={{ color: textColor }} />;
                break;
            case "info":
            default:
                renderedIcon = <InfoRoundedIcon sx={{ color: textColor }} />;
        }
    }
    return (
        <Box
            sx={{
                padding: theme.spacing(1),
                background: theme.palette[color][100],
                gap: theme.spacing(2),
                borderRadius: 1,
                display: "flex",
                color: textColor,
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                ...sx,
            }}
        >
            {renderedIcon}
            <Typography
                component={childComponent}
                sx={{
                    ...childrenSx,
                }}
            >
                {children}
            </Typography>
        </Box>
    );
};
